import { HiddenMobile } from '../LayoutWithLeftDesktopNav/Reusable/HiddenMobile/HiddenMobile';
import { css } from '@bts-web/utils-style-engine';
import { TradeSkeletons } from '../../trade/Reusable/Skeletons';
import { AssetDetailsHeaderSkeleton } from '../../asset-details/AssetDetailsLoadingSkeleton.server';

export const AssetDetailsContentSkeletonForTradePage = () => {
  return (
    <div className={css({ display: 'flex', width: '100%' })}>
      <HiddenMobile className={css({ width: '100%' })}>
        <AssetDetailsHeaderSkeleton />
      </HiddenMobile>

      <TradeSkeletons.TradeSkeleton />
    </div>
  );
};
